<template>
  <button :class="btnClass" @click="chat"><slot></slot></button>
</template>

<script>
import { TfChatLink } from 'tf-chat'
export default {
  name: 'ChatButton',
  emits: ['chatOpen'],
  props: {
    expertID: { type: Number, default: 0 },
    tripID: { type: Number, default: 0 },
    enquiryID: { type: Number, default: 0 },
    btnClass: { type: String },
    type: { type: String, default: '' },
    followTripID: { type: Number, default: 0 }
  },
  setup(props, { emit }) {
    const chat = () => {
      switch (props.type) {
        case 'enquiry-3w':
          TfChatLink.push({enquiryId : props.enquiryID, type: props.type, lsId: props.expertID, extraData: {}, ask_follow_up: props.followTripID})
          break
        case 'enquiry-2w':
          TfChatLink.push({enquiryId: props.enquiryID, type: props.type})
          break
      }
      emit('chatOpen');
    }

    return { chat }
  }
}
</script>

<style scoped>

</style>
